import React from 'react';
import SimulationDiffDisplay from './SimulationDiffDisplay';
import { SimulationDiffData } from './types';

interface MessageSimulationDiffProps {
  simulationDiffTags: any[];
  interruptData?: SimulationDiffData | null;
  isStreaming: boolean;
  visible?: boolean; // gate on parent visibility rules if needed
  messageId?: number | string | null;
  isLastMessage?: boolean;
}

const MessageSimulationDiff: React.FC<MessageSimulationDiffProps> = ({
  simulationDiffTags = [],
  interruptData = null,
  isStreaming,
  visible = true,
  isLastMessage = false,
}) => {
  if (!visible || (isStreaming && isLastMessage)) return null;

  const hasTags = Array.isArray(simulationDiffTags) && simulationDiffTags.length > 0;
  const hasInterrupt = !!interruptData;
  if (!hasTags && !hasInterrupt) return null;

  const renderFromTags = () => {
    if (!hasTags) return null;
    return simulationDiffTags.map((diffTag: any, idx: number) => {
      try {
        const jsonMatch = diffTag.content && String(diffTag.content).match(/<simulation_diff>([\s\S]*?)<\/simulation_diff>/);
        if (jsonMatch && jsonMatch[1]) {
          const simulationData: SimulationDiffData = JSON.parse(jsonMatch[1]);
          return (
            <SimulationDiffDisplay
              key={`simulation-diff-tag-${idx}`}
              diffData={simulationData}
            />
          );
        }
      } catch (_) {
        return null;
      }
      return null;
    });
  };

  const renderFromInterrupt = () => {
    if (!hasInterrupt) return null;
    return (
      <SimulationDiffDisplay key={`simulation-diff-sse`} diffData={interruptData as SimulationDiffData} />
    );
  };

  return (
    <div className="simulation-diffs mt-4">
      {renderFromTags()}
      {!hasTags && renderFromInterrupt()}
    </div>
  );
};

export default MessageSimulationDiff; 